<template>
  <div id="home">
    <headerBar ref="headerRef" />
    <div class="certer" id="web-center">
      <router-view />
      <bottomInfo :informationData="informationData" />
    </div>
    <div class="rightfixedBar" v-show="isShowFixed">
      <div class="fixedBox">
        <div class="fixedItem" @click="onlineClick">
          <img class="img" src="../assets/img/onlineKfIcon.png" alt="" />
          <div class="text">在线客服</div>
        </div>
        <el-tooltip placement="left" effect="light">
          <template #content>
            <img
              style="width: 100px; height: 100px"
              :src="informationData.rencaiku"
              alt=""
            />
            <div
              class="hoverYingpinText"
              style="font-size: 12px; color: #333; text-align: center"
            >
              正华源人才库
            </div>
          </template>
          <div
            class="fixedItem"
            @mouseenter="onMousemoveYingpin"
            @mouseleave="onMouseleaveYingpin"
          >
            <img src="../assets/img/yingpinzuliIcon.png" alt="" />
            <div class="text">应聘助理</div>
          </div>
        </el-tooltip>
        <!-- <div
          class="fixedItem"
          @click="
            ElMessage({
              message: '正在开发中...',
              type: 'warning',
            })
          "
        >
          <img src="../assets/img/yuyueIcon.png" alt="" />
          <div class="text">预约</div>
        </div> -->
        <div class="fixedItem" @click="onClickBackTop()">
          <img src="../assets/img/backTopIcon.png" alt="" />
          <div class="text">返回顶部</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/api/index";
import headerBar from "@/components/headerBar.vue";
import bottomInfo from "@/components/bottomInfo.vue";
import { Message } from "element-ui";
export default {
  components: {
    headerBar,
    bottomInfo,
  },
  data() {
    return {
      scrollTopNum: null,
      informationData: {},
      isShowFixed: false,
      headerRef: {
        isHomeActived: false,
      },
    };
  },
  methods: {
    onMousemoveYingpin() {},
    onMouseleaveYingpin() {},
    onlineClick() {
      Message.closeAll();
      Message({
        duration:1000,
        message: "正在开发中...",
        type: "warning",
      });
    },
    // 返回顶部
    onClickBackTop() {
      this.$nextTick(() => {
        document.getElementById("web-center").scrollTop = 0;
      });
    },
    // 控制fixed栏显示隐藏及顶部菜单栏状态
    scrollToTop() {
      this.scrollTopNum = document.getElementById("web-center").scrollTop;
      if (this.scrollTopNum > 60) {
        this.isShowFixed = true;
        document.getElementById(
          "headerBar"
        ).style.background = `rgba(255,255,255,1)`;
        document.getElementById("headerBar").style.border = `1px solid #d8dce4`;
        document.querySelector("#headerBar").classList = "addFixed";
        if (this.$route.path === "/home/index") {
          this.headerRef.isHomeActived = true; // 切换logo为正常色(红色)
        }
      } else {
        this.isShowFixed = false;
        if (this.$route.path === "/home/index") {
          this.headerRef.isHomeActived = false; // 切换logo为透明色
        }
        document.getElementById(
          "headerBar"
        ).style.background = `rgba(255,255,255,0)`;
        document.getElementById("headerBar").style.border = `0`;
        document.querySelector("#headerBar").classList.remove("addFixed");
      }
    },
  },
  async mounted() {
    window.addEventListener("scroll", this.scrollToTop, true);
    const ciRes = await Api.getCompanyInformation.get();
    if (ciRes.code === 200) {
      this.informationData = ciRes.data.list.list;
      if (this.informationData.length) {
        this.informationData = this.informationData[0];
      }
    }
  },
};
</script>

<style lang="scss">
#home {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  .certer {
    flex: 1;
    overflow: scroll;
  }
  .rightfixedBar {
    background: #fff;
    position: fixed;
    z-index: 999;
    right: 0px;
    top: 50%;
    width: 78px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 2px 20px 0px rgba(132, 49, 49, 0.17);
    .fixedBox {
      margin-top: 10px;
    }
    .fixedItem {
      cursor: pointer;
      margin-bottom: 13px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      img {
        margin-bottom: 7px;
      }
      .text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
      }
    }
  }
}
</style>
